import * as React from "react";
import { useState, useEffect } from "react";
import styled from "styled-components";
import { UserData, UserDataFilter } from ".";
import Select from "react-select";
import { MultiValue } from "react-select";

interface Props {
  users: UserData[];
  existingFilters: UserDataFilter[];
  onAdd: (filter: UserDataFilter[]) => void;
  closeModal: () => void;
}

interface DropdownOption {
  id: number;
  label: string;
  value: string;
}

const Wrapper = styled.div`
  width: 500px;
  max-width: 100%;

  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  & .buttons {
    display: flex;
    gap: 0.5rem;

    & > * {
      flex-grow: 1;
      margin-bottom: 0;
    }
  }
`;

const AddUserFilterModal = ({
  users,
  existingFilters,
  onAdd,
  closeModal,
}: Props) => {
  const [selectedUsers, setSelectedUsers] = useState([] as UserData[]);
  const [options, setOptions] = useState([] as DropdownOption[]);

  useEffect(() => {
    let newOptions = users
      .filter((u) => !existingFilters.find((u2) => u.id === u2.id))
      .map((u) => ({
        id: u.id,
        value: u.id.toString(),
        label: u.name,
      }));

    setOptions(newOptions);
  }, [users]);

  const getNoOptionsMessage = ({ inputValue }): React.ReactNode => {
    return <span>Ingen personal matchade namnet</span>;
  };

  const onSelectedOptionsChange = (newValues: MultiValue<DropdownOption>) => {
    const newSelectedUsers = newValues.map(
      (val) => users.find((user) => user.id === val.id)!
    );
    setSelectedUsers(newSelectedUsers);
  };

  const addUsersAndCloseModal = () => {
    const users = selectedUsers;
    setSelectedUsers([]);
    onAdd(users);
    closeModal();
  };

  return (
    <Wrapper>
      <div className="users-select">
        <Select
          autoFocus={true}
          isMulti={true}
          options={options}
          noOptionsMessage={getNoOptionsMessage}
          onChange={onSelectedOptionsChange}
          defaultMenuIsOpen={true}
          placeholder="Välj personal..."
        />
      </div>
      <div className="buttons">
        <button
          className="button primary"
          onClick={addUsersAndCloseModal}
          disabled={!selectedUsers.length}
        >
          Ok
        </button>
        <button className="button secondary" onClick={closeModal}>
          Avbryt
        </button>
      </div>
    </Wrapper>
  );
};

export default AddUserFilterModal;
